import React from 'react';

const HowToPlayModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const closeModal = (event) => {
    if (event.currentTarget === event.target) {
      onClose();
    }
  };

  return (
    <div className="modal-backdrop" onClick={closeModal}>
      <div className="modal-content">
        <div className="modal-header">
          <h2 className="modal-title">How To Play</h2>
          <button onClick={onClose} className="close-button">&times;</button>
        </div>
        <div className="modal-body modal-body-scroll">
          <p>Welcome to Movie Quest! Your goal is to guess the secret movie. Here's how you can play and win:</p>
          <ol>
            <li><strong>Start Your Game:</strong> Select a year range to narrow down the possible movie pool, making your challenge easier or harder. You can also toggle between Easy Mode (where blockbuster films are chosen) and Hard Mode for a wider range of movies.</li>
            <li><strong>Make a Guess:</strong> Type in the title of the movie you think is the secret film. Don't worry about exact titles—our system will find the closest match for you to select.</li>
            <li><strong>Review Feedback:</strong> After each guess, you'll receive feedback comparing your guess to the secret movie across several criteria: director, release year, genres, cast, runtime, rating, and box office earnings. Use this information to refine your next guess.</li>
            <li><strong>Use Hints Wisely:</strong> Feeling stuck? You can reveal hints about the secret movie. Be strategic, though! The fewer hints you use, the more impressive your guesswork.</li>
            <li><strong>Win or Learn:</strong> Guess the movie correctly to win. If you give up or want to explore, we'll reveal the movie so you can discover something new or enjoy a favorite again.</li>
          </ol>
          <p className="modal-note">Hints Available: Director, Release Year, Genres, Cast, Runtime, Rating, and Box Office. Each hint you reveal gets you closer to the answer but challenges your cinema knowledge!</p>
          <p>Ready to test your movie mastery? Close this guide, adjust your settings, and start guessing. Good luck!</p>
        </div>
        <div className="modal-footer">
          <button onClick={onClose} className="close-modal-button">Close</button>
        </div>
      </div>
    </div>
  );
};

export default HowToPlayModal; 